import { render, staticRenderFns } from "./PaquetesForm.vue?vue&type=template&id=be8e17dc&scoped=true"
import script from "./PaquetesForm.vue?vue&type=script&lang=js"
export * from "./PaquetesForm.vue?vue&type=script&lang=js"
import style0 from "./PaquetesForm.vue?vue&type=style&index=0&id=be8e17dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8e17dc",
  null
  
)

export default component.exports